import React from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../../labelling-v2/components/stage-scope/hooks';
type PropsT = {
  imageUrl: string;
  onLoad: (width: number, height: number) => void;
  onError: () => void;
};
const StyledImage = styled<'img', {
  $brightness: number;
  $contrast: number;
}>('img', ({
  $brightness,
  $contrast
}) => ({
  width: '100%',
  height: '100%',
  filter: `brightness(${$brightness}%) contrast(${$contrast}%)`
}));
const Image = ({
  imageUrl,
  onLoad,
  onError
}: PropsT) => {
  const {
    imageSettingsAtom
  } = useStageAtoms();
  const {
    brightness,
    contrast
  } = useAtomValue(imageSettingsAtom);
  return <StyledImage src={imageUrl} alt="labelling-image" onLoad={e => onLoad((e.target as HTMLImageElement).naturalWidth, (e.target as HTMLImageElement).naturalHeight)} onError={() => onError()} $brightness={brightness} $contrast={contrast} />;
};
export default Image;